import { useEffect, useState } from "react";
import classnames from "classnames";
import { Badge } from "reactstrap";
import { PhotoProvider, PhotoView } from "react-photo-view";
import { getRandomKey } from "@src/Services/Helpers/Actions";

const Avatar = ({
  img,
  size,
  icon,
  color = "primary",
  status,
  badgeUp,
  content,
  Tag = 'div',
  initials = true,
  imgWidth,
  className = 'me-25',
  badgeText,
  imgHeight,
  badgeColor,
  imgClassName,
  contentStyles,
  imgOnError = undefined,
  withPreview = false ,
  refreshKey = getRandomKey() , // to render component
  useBorder = true
}) => {

  const [error, setError] = useState(false);
  const handleError = (e) => {
    if (imgOnError) {
      e.target.src = imgOnError;
    } else {
      setError(true);
    }
  };
  // ** Function to extract initials from content
  const getInitials = (str) => {
    const results = [];
    try {
      const wordArray = str?.split(" ") || [];
      wordArray.forEach((e) => {
        results.push(e[0]);
      });
      return results.join("")?.slice(0, 2);
    } catch (error) {
      return <>&#8213;</>;
    }
  };

  useEffect(() => {
    if (img || imgOnError) {
      setError(false);
    }
  }, [img, imgOnError]);

  return (
    <Tag
      className={classnames(
        `avatar justify-content-center align-items-center text-uppercase ${!error && !!img && useBorder ? 'border' : ''}`,
        {
          [className]: className,
          [`bg-${color}`]: error || !img ? color : '',
          [`avatar-${size}`]: size
        }
      )}
      style={{width: imgWidth && !size ? imgWidth : 32, height: imgHeight && !size ? imgHeight : 32}}
      key={refreshKey}
    >
      {(!img && !imgOnError) || error ? (
        <span
          className={classnames("avatar-content", {
            "position-relative": badgeUp
          })}
          style={contentStyles}
        >
          {initials ? getInitials(content) : content}
          {icon ? icon : null}
          {badgeUp ? (
            <Badge color={badgeColor ? badgeColor : "primary"} className="badge-sm badge-up" pill>
              {badgeText ? badgeText : "0"}
            </Badge>
          ) : null}
        </span>
      ) : (
        withPreview ? 
          <PhotoProvider>
            <PhotoView src={img}> 
              {/* we can't make img as components because photoView need wrapped element not a dom (component) */}
              <img 
                className={classnames({
                  [imgClassName]: imgClassName
                })}
                src={img ?? imgOnError}
                alt="LOGO"
                height={imgHeight && !size ? imgHeight : 32}
                width={imgWidth && !size ? imgWidth : 32}
                onError={e => handleError(e)}
              />
            </PhotoView>
          </PhotoProvider>
          : 
          <img
            className={classnames({
              [imgClassName]: imgClassName
            })}
            src={img ?? imgOnError}
            alt="LOGO"
            height={imgHeight && !size ? imgHeight : 32}
            width={imgWidth && !size ? imgWidth : 32}
            onError={e => handleError(e)}
          />
      )}
      {status ? (
        <span
          className={classnames({
            [`avatar-status-${status}`]: status,
            [`avatar-status-${size}`]: size
          })}
        ></span>
      ) : null}
    </Tag>
  );
};

export default Avatar;